/**
 * The `document.body` dataset key the PDF pipeline waits on to know the public
 * quote page has finished rendering (styles applied, pagination settled). Set
 * by both the legacy template path and the HTML-document path so the PDF action
 * can wait on one body-level attribute regardless of which path rendered.
 */
export const BODY_RENDER_COMPLETE_KEY = "fpRenderComplete";

/**
 * Stamps `document.body.dataset.fpRenderComplete = "true"`, the signal the PDF
 * renderer (Puppeteer) waits on before capturing the page. Safe to call when
 * there is no document (e.g. during SSR-less tests): it no-ops without a body.
 */
export function markBodyRenderComplete(): void {
  if (typeof document === "undefined" || !document.body) {
    return;
  }
  document.body.dataset[BODY_RENDER_COMPLETE_KEY] = "true";
}

/**
 * Clears the render-complete signal from `document.body`, so a re-render (e.g. a
 * new quote loading into the same page) re-arms the PDF pipeline's wait.
 */
export function clearBodyRenderComplete(): void {
  if (typeof document === "undefined" || !document.body) {
    return;
  }
  delete document.body.dataset[BODY_RENDER_COMPLETE_KEY];
}
